module.exports = "<button (click)=\"sendParent()\" type=\"button\" class=\"{{icon}}\" [disabled]=\"disabled\"><em>{{text}}</em></button>\n"